import { identify } from "@dash0/sdk-web"
import { LANGUAGE_MAP } from "@kamae-apps/shared/Types/Company"
import { SCOPE } from "@kamae-apps/shared/Types/Scope"
import posthog from "posthog-js"
import { useEffect } from "react"
import { useUser } from "../Contexts/User/UserContext"
import { getCompanyPlan, sha1 } from "../utils"

// Identifies the current user across PostHog and Dash0 and fires a pageview.
export function useAnalytics() {
  const { user } = useUser()

  useEffect(() => {
    if (typeof user.scope !== "undefined") {
      // if user fully loaded
      identify(user.email, {
        email: user.email,
        fullName: `${user.first_name} ${user.last_name}`,
      })

      sha1(user.email).then(identifier => {
        posthog.register({
          // Capturing this numerical value for every event.
          // It should be captured as a person property instead, but for now
          // we have not been able to compute metrics based on a numerical
          // person property in PostHog (besides using HogSQL).
          company_total_users: user.company.total_user,
        })
        posthog.identify(identifier, {
          company_name: user.company.name,
          company_plan: getCompanyPlan(user.company.status),
          company_total_users: user.company.total_user,
          team_name: user.team.name,
          team_total_users: user.team.user_count,
          user_role: SCOPE[user.scope ?? SCOPE.USER],
          user_language: LANGUAGE_MAP[user.languageId],
          browser_language: navigator.language,
        })
        posthog.group("Company", `id:${user.company.id}`, {
          name: user.company.name,
        })
      })
    }
  }, [user])

  useEffect(() => {
    sha1(user.email).then(identifier => {
      posthog.identify(identifier)
      posthog.capture("$pageview")
    })
    window.scrollTo({ top: 0 })
  }, [user.email])
}
